/* 
--- DEVELOPER WARNING ---
This is a generated file.
Any changes you make to this file will not be saved nor git tracked. 
*/

import chat_IconURL from '../RAISE_Logo.png';
import chat_InsetIconURL from '../PRG_Logo.png';
import React from 'react';
import { FormattedMessage } from 'react-intl';
export default {
	name: 
  (
    <FormattedMessage
        defaultMessage="GenAI Extension"
        description="name for the GenAI Extension extension"
        id="extension.chat.name"
    />
  ),
	description: 
  (
    <FormattedMessage
        defaultMessage="Use generative AI to listen, speak, and chat!"
        description="description for the GenAI Extension extension"
        id="extension.chat.description"
    />
  ),
	iconURL: chat_IconURL,
	insetIconURL: chat_InsetIconURL,
	featured: true,
	extensionId: 'chat',
}